import { runInAction } from 'mobx';
import presizeBackendRest from '../../services/presize-backend-rest';
import { SizingStore } from './sizing-store';
import { Brand } from '../../models/brand';

export class GetReferenceBrandsAction {
  async getReferenceBrands(this: SizingStore): Promise<void> {
    const restResponse = await presizeBackendRest.getReferenceBrands({
      cg_code: this.cgCode2,
      season_code: this.seasonCode,
    });
    const brands = restResponse.reference_brands ?? [];

    runInAction(() => {
      this.referenceBrands.rawBrands = brands.map((brand) => ({
        code: brand.code,
        name: brand.name,
        filterablestr: `${brand.name}${brand.code}`.toLowerCase().replace(/\s/g, ''),
      }));
      this.processReferenceBrandsMap();
      this.processReferenceBrandsWithUsage();
    });
  }
  processReferenceBrandsWithUsage(this: SizingStore): void {
    const usedBrands: Array<Brand> = [];
    const similarBrands: Array<Brand> = [];
    const usedReferenceBrandCodes = new Set(
      this.sizingGroups.map((sg) => sg.sizing?.referenceBrandCode || '').filter((x) => !!x)
    );
    this.referenceBrands.rawBrands.forEach((b) => {
      if (usedReferenceBrandCodes.has(b.code)) {
        usedBrands.push(b);
      } else {
        similarBrands.push(b);
      }
    });
    runInAction(() => {
      this.referenceBrands.processedBrands = { usedBrands, similarBrands };
    });
  }
  processReferenceBrandsMap(this: SizingStore): void {
    runInAction(() => {
      this.referenceBrands.brandsMap = this.referenceBrands.rawBrands.reduce(
        (prev, curr) => ({ ...prev, [curr.code]: curr }),
        {}
      );
    });
  }
}
